module.exports = __webpack_public_path__ + "img/core_duihua.55c87bd5.png";